import http from "../httpService";
import {getBaseUrl} from "../../config.js";


export const getFileNameByCode = code => {
  return http.get(
    `${getBaseUrl()}/file_name/${code}`
  );
};

export const getThumbFileUrl = code => {
  return http.get(
    `${getBaseUrl()}/serve_file_thumb/${code}`
  );
};